import React from 'react'
import { Login, ForgotPassword, ResetPassword, EmailVerification } from '../pages'

export const authRoutes: RouteType[] = [
    {
        path: 'login',
        element: <Login />
    },
    {
        path: 'email-verification',
        element: <EmailVerification />
    },
    {
        path: 'forgot-password',
        element: <ForgotPassword />
    },
     {
        path: 'reset-password',
        element: <ResetPassword />
    }
]